module.exports = __webpack_public_path__ + "static/Doaa-96637ee3a9dd428d766fe8e5acbb43fe.png";